jQuery(function($) {
    /**
     * Fix modal backgrounds scrolling on ios.
     *
     * For some reason ios does not respect 'overflow: hidden' on a body tag,
     * and the only way to work around this seems to be to set 'position: fixed' on the root html tag.
     * This causes problems with the scroll position when the modal is closed.
     * Additionaly the modal body's height was also not being set correctly on ios.
     *
     * Manage the setting of 'position: fixed', the page scroll position, and the modal body's height.
     */
    if (/ipad|iphone/i.test(window.navigator.userAgent)) {
        var jqHtml = jQuery('html');
        var jqWindow = jQuery(window);
        var jqHtmlBody = jQuery('html, body');

        var windowHeight = jqWindow.height();
        var remSize = parseFloat(
            getComputedStyle(document.documentElement).fontSize
        );
        var maxModalHeight = windowHeight - 3 * remSize;

        jQuery('*[data-toggle="modal"]').each(function() {
            var modalTrigger = jQuery(this);
            var modal = jQuery(
                modalTrigger.data('target') || modalTrigger.attr('href')
            );

            modal.on('show.bs.modal', function() {
                // Use an offset from the element clicked to open the modal to return to the scroll position before opening the modal,
                // as the opening and closing of the modal can cause some elements to change size, so taking an absolute position would scroll back to the wrong place.
                var scrollOffset =
                    modalTrigger.offset().top - jqWindow.scrollTop();

                jqHtml.addClass('ios-modal-open');

                // Add this event listener using `one`, so that after it is triggered it is removed.
                // This is done as it is added during the handler for the modal being shown, so if it was not removed and the modal was triggered again it would be added multiple times.
                modal.one('hide.bs.modal', function() {
                    jqHtml.removeClass('ios-modal-open');
                    jqHtmlBody.animate(
                        {scrollTop: modalTrigger.offset().top - scrollOffset},
                        0
                    );
                });
            });

            var modalBody = modal.find('.modal-body');

            modal.on('shown.bs.modal', function() {
                // Only change the max-height property if the height is greater than the max,
                // as it is possible the element could already have a smaller max-height property, and blindly setting a new max-height would mess that up.
                if (modalBody.height() > maxModalHeight)
                    modalBody.css('max-height', maxModalHeight);
            });
        });

        // Do essentially same thing but for nav menu
        var navOpen = function() {
            jQuery('.nav-trigger').off('click', navOpen);

            var navScrollPos = jqWindow.scrollTop();
            jqHtml.addClass('ios-modal-open');

            var navClose = function() {
                jQuery('.nav-trigger').off('click', navClose);

                jqHtml.removeClass('ios-modal-open');
                jqHtmlBody.animate({scrollTop: navScrollPos}, 0);

                jQuery('.nav-trigger').one('click', navOpen);
            };

            jQuery('.nav-trigger').one('click', navClose);
        };
        jQuery('.nav-trigger').one('click', navOpen);
    }
});